import { useEffect } from 'react'

function Logout() {
  useEffect(() => {
    // Clear ALL localStorage to ensure completely clean state
    localStorage.clear()

    // Use window.location for full page navigation
    // This prevents Zustand's persist middleware from writing back empty state
    window.location.href = '/login'
  }, [])

  return (
    <div className="flex-1 flex items-center justify-center p-4" data-testid="logout-page">
      <p>Logging out...</p>
    </div>
  )
}

export default Logout
